import styled from "styled-components"

export const Title = styled.h2`
  display: flex;
  align-items: center;

  svg {
    height: 2.8rem;
    width: 2.8rem;
    margin-right: 1rem;
  }
`

export const Banner = styled.div`
  background: ${(p) => p.theme.colors.turquoiseDarker};
  color: ${(p) => p.theme.colors.white};
  font-weight: 700;
  position: absolute;
  transform-origin: 50% 50%;
  font-size: 1.1rem;
  width: 10rem;
  display: flex;
  justify-content: center;
  left: -2.4rem;
  top: 1.3rem;
  rotate: -45deg;

  &:before {
    content: "";
    position: absolute;
    top: -0.1rem;
    right: -0.1rem;
    rotate: 180deg;
    border-top: 2.7rem solid transparent;
    border-left: 2.7rem solid ${(p) => p.theme.colors.white};
    width: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: -0.1rem;
    left: -0.1rem;
    rotate: 90deg;
    border-top: 2.7rem solid transparent;
    border-left: 2.7rem solid ${(p) => p.theme.colors.white};
    width: 0;
  }
`

export const StyledOrderLines = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 2rem;
  background: ${(p) => p.theme.colors.white};
`

export const Status = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.orange};
  color: ${(p) => p.theme.colors.orange};
  background: ${(p) => p.theme.colors.yellowLight};
  width: 8rem;
  display: flex;
  justify-content: center;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
  font-weight: 700;
`



export const TotalsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  align-self: flex-end;
`

export const GrandTotal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const Label = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1.6rem;
`

export const Total = styled.div`
  font-size: 2.8rem;
  line-height: 1rem;
  font-weight: 700;
  margin-bottom: 2rem;
`

export const DiscountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  font-size: 1.2rem;
  padding: 0 0.5rem;
`

export const DiscountRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0;
`

export const Value = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
`
export const Id = styled.div`
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDark};
  line-height: 1.8rem;

  a {
    color: ${(p) => p.theme.colors.greyDark};
    text-decoration: underline;
  }
`
